import React, { useState, useEffect } from 'react';
import axios from 'axios';
import {
  TableContainer,
  Paper,
  Table,
  TableHead,
  TableBody,
  TableRow,
  TableCell,
  Select,
  MenuItem,
} from '@mui/material';
import './Users.css'
const classOptions = [
  { label: 'Class 8A', value: '61927a30-c334-4d75-91a4-3fb7cfcdb12d' },
  { label: 'Class 8B', value: '365302c6-d2b7-409f-8ad2-555b12b586fa' },
  { label: 'Class 8C', value: '7b130629-16dc-49be-a2fc-d0212f28899c' },
  { label: 'Class 9A', value: '40087d29-5ad4-4451-addb-8690e85c44d3' },
  { label: 'Class 9B', value: '3f7ba2cb-78db-4718-94c6-3d80e5ddbdb7' },
  { label: 'Class 9C', value: 'bc80e816-2c5e-4f8d-a2b8-9a67368b292b' },
  { label: 'Class 10A', value: '6c565740-996b-4675-b28c-b3c84b158deb' },
  { label: 'Class 10B', value: 'cc3a2570-fd43-43fe-bf97-f2c52c4abe8c' },
  { label: 'Class 10C', value: 'cb9781b9-f26a-46a1-a221-b346b0960530' },
];

function UserDetails() {
  const [users, setUsers] = useState([]);
  const [selectedClass, setSelectedClass] = useState('');
  const [filteredUsers, setFilteredUsers] = useState([]);

  useEffect(() => {
    if (selectedClass) {
      fetchUsers(selectedClass);
    }
  }, [selectedClass]);

  const fetchUsers = async (classId) => {
    try {
      const response = await axios.get(
        `http://localhost:3000/organizations/api/users/${classId}`
      );
      console.log('API Response:', response.data);
      setUsers(response.data);
    } catch (error) {
      console.error('Error fetching user details:', error);
    }
  };

  useEffect(() => {
    if (selectedClass === '') {
      setFilteredUsers(users);
    } else {
      const filteredData = users.filter((user) => user.classId === selectedClass);
      setFilteredUsers(filteredData);
    }
  }, [selectedClass, users]);

  return (
    <div className="user-details-page">
      <h2 className="head">User Details</h2>
      <Select
        className="selectNeedType"
        name="classFilter"
        value={selectedClass}
        onChange={(e) => setSelectedClass(e.target.value)}
      >
        <MenuItem value="">All Classes</MenuItem>
        {classOptions.map((option) => (
          <MenuItem key={option.value} value={option.value}>
            {option.label}
          </MenuItem>
        ))}
      </Select>
      <TableContainer component={Paper} className="table-responsive-wrap">
        <Table className="table" aria-label="Users table">
          <TableHead className="table-header-row">
            <TableRow>
              <TableCell className="table-header-cell">First Name</TableCell>
              <TableCell className="table-header-cell">Gender</TableCell>
              <TableCell className="table-header-cell">Date of Birth</TableCell>
              <TableCell className="table-header-cell">City</TableCell>
              <TableCell className="table-header-cell">Email</TableCell>
              <TableCell className="table-header-cell">Phone</TableCell>
            </TableRow>
          </TableHead>
          <TableBody className="table-body">
            {filteredUsers.map((user) => (
              <TableRow key={user.userId} className="table-row">
                <TableCell className="table-cell" data-label="First Name">{user.userDetails.firstname}</TableCell>
                <TableCell className="table-cell" data-label="Gender">{user.userDetails.gender}</TableCell>
                <TableCell className="table-cell" data-label="Date of Birth">{user.userDetails.dateOfBirth}</TableCell>
                <TableCell className="table-cell" data-label="City">{user.userDetails.address.city}</TableCell>
                <TableCell className="table-cell" data-label="Email">{user.userDetails.contact.email}</TableCell>
                <TableCell className="table-cell" data-label="Phone">{user.userDetails.contact.phone}</TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    </div>
  );
}

export default UserDetails;
